<template>

<core-modal v-on:close="onClose" :nopadding="true">

	<template v-slot:head>

		Browse Indexes

	</template>

	<template v-slot:default>

        <div class="browse-empty" v-if="!indexes.length">No matching indexes found.</div>

        <div class="index" v-for="index in indexes" :key="index.id" v-tooltip="'Click to subscribe'" v-on:click="onIndexClick(index)">

            <div class="index-name">{{ index.name }}</div>
            <div class="index-tracking" v-if="isTracking(index.id)">Tracking</div>
            <div class="index-description">{{ index.description }}</div>

            <div class="index-foot">

                <div class="index-author">@{{ index.author }}</div>
                <div class="index-users">{{ index.users }} user<template v-if="index.users != 1">s</template></div>

            </div>

        </div>

	</template>

	<template v-slot:foot>

        <input type="text" v-model="search" placeholder="Filter by name..." class="browse-search" />

	</template>

</core-modal>

</template>

<script>

export default {

	props: ['data'],

	data: function() {

		return {

            search: '',

			is: {
				loading: false
			}

		}

	},

    computed: {

        indexes: function() {

            if (!this.search) return this.$_.filter(this.hindex.indexes, function(index) {

                return index.public

            })

			return this.$_.filter(this.hindex.indexes, function(index) {

                return (index.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 || index.author.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) && index.public

            }.bind(this))

		},

        hindex: function() {

			return this.$store.getters['page/insights/hindex/indexes']

		}

    },

	methods: {

        isTracking: function(id) {

            return this.$_.contains(this.hindex.tracking, id)

        },

        onIndexClick: function(index) {

            this.$pubsub.$emit('open.modal', {
				id: 'hindexView',
                index: index
			})

        },

		onConfirmClick: function() {

            //

		},

		onClose: function() {

			this.$emit('close')

		}

	}

}

</script>

<style scoped>

.index {
    padding: 20px;
    border-bottom: 1px solid #254b5f;
    cursor: pointer;
    user-select: none;
}

.is-desktop .index:hover {
    background-color: #254b5f;
}

.index-tracking {
    position: absolute;
    right: 20px;
    top: 20px;
    padding: 2px 4px;
    font-size: 12px;
    font-weight: 400;
    background-color: #4881bb;
    color: #fff;
    border-radius: 4px;
}

.index-name {
    font-weight: 700;
    color: #fff;
    font-size: 16px;
}

.index-description {
    margin-top: 4px;
    font-weight: 400;
    color: #fff;
    line-height: 18px;
    font-size: 14px;
}

.index-author {
    font-weight: 400;
    opacity: 0.75;
    color: #fff;
    font-size: 12px;
    margin-top: 10px;
}

.index-users {
    font-weight: 400;
    opacity: 0.75;
    color: #fff;
    font-size: 12px;
    margin-top: 10px;
}

.index-foot {
    display: flex;
    justify-content: space-between;
}

.browse-empty {
    padding: 50px 20px;
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 18px;
}

.browse-search {
    border-radius: 4px;
    background-color: #fff;
    height: 40px;
    font-size: 14px;
    color: #333;
    line-height: 40px;
    padding: 0px 10px;
}

</style>